<template>
  <svg
    class="mole"
    :class="[type, spacing, { reversed, vertical }]"
    :width="width"
    viewBox="0 0 281 165"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
  >
    <path
      d="M149.133 164.891L0 164.891L161.856 19.0844C189.865 -6.14818 232.728 -5.03101 259.386 21.6264C289.141 51.3815 286.56 100.359 253.843 126.823L206.777 164.891L149.133 164.891Z"
    />
  </svg>
</template>

<script>
import { computed } from '@vue/composition-api';

export default {
  props: {
    type: {
      type: String,
      default: 'warning',
    },
    reversed: {
      type: Boolean,
      default: false,
    },
    spacing: {
      type: String,
      default: 'sm',
    },
    scale: {
      type: Number,
      default: 1,
    },
    vertical: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    return {
      width: computed(() => 281 * props.scale),
    };
  },
};
</script>

<style lang="postcss" scoped>
.mole {
  @apply -ml-xxl;

  &:not(:last-of-type) {
    @apply mr-huge;

    .sm& {
      @apply mr-xxl;
    }
    .md& {
      @apply mr-[6rem];
    }
  }

  &.reversed {
    @apply !mx-0 self-start rotate-180 ;

    &.vertical {
      @apply -rotate-90 !ml-xl;
    }
  }
  &.vertical {
    @apply rotate-90 !mr-xl;
  }

  .lg& {
    @apply -ml-giant;
  }
  .xl& {
    @apply -ml-[20rem];
  }
  .xxl& {
    @apply -ml-[30rem];
  }

  path {
    @apply opacity-40;

    .warning& {
      @apply fill-feedback-alert-light;
    }
    .info& {
      @apply fill-support-medium;
    }
    .error& {
      @apply fill-feedback-error-lightest;
    }
    .success& {
      @apply fill-feedback-success-light;
    }
  }
}
</style>
